/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-19 11:19:45
 * @FilePath: /unifyxp-v2-store-portal/src/pages/InventoryList/InventoryListConfig.tsx
 */

import { IWarehouse } from 'src/types/common/warehouse';

export enum ECustomTab {
  All = 'All',
}

const tabsConfig = (warehouses, { getI18n }) => {
  const arr = warehouses.map((i: IWarehouse) => {
    const { uuid, locationName } = i;
    return {
      name: locationName,
      key: uuid,
    };
  });
  return [
    //定义tabs列表
    { name: getI18n('general.export1.all'), key: ECustomTab.All },
    ...arr,
  ];
};
const breadcrumbData = ({ getI18n }) => [
  {
    url: '',
    name: getI18n('general.sider.home'),
  },
  {
    url: '',
    name: getI18n('general.products'),
  },
  {
    url: '',
    name: getI18n('inventory.inventory.list_general_pageLayoutProps_title'),
  },
];

export { breadcrumbData, tabsConfig };
